import React, { useState } from "react";
import Modal from "../../Elements/Modal/Modal";
import MainButton from "../../Elements/MainButton/MainButton";
import SecondButton from "../../Elements/SecondButton/SecondButton";
import ErrorMessage from "../../Elements/ErrorMessage/ErrorMessage";
import SuccessMessage from "../../Elements/SuccessMessage/SuccessMessage";
import { requestRefund } from "../../../services/EsimService";
import "./RefundModal.css";

const RefundModal = ({ isOpen, onClose, iccid }) => {
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const handleSubmit = async () => {
    if (!reason.trim()) {
      setError("Please provide a reason for the refund.");
      return;
    }

    setLoading(true);
    setError("");

    try {
      await requestRefund(iccid, reason);
      setSuccess(true);
      // Nie czyścimy 'reason' od razu, żeby użytkownik widział co wysłał,
      // ale pole będzie zablokowane (disabled)
    } catch (err) {
      setError(err?.response?.data?.detail || "Failed to submit refund request. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setError("");
    setSuccess(false);
    setReason("");
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title="Request Refund"
      // Akcje (przyciski) ukrywamy tylko, gdy jest sukces,
      // bo wtedy wyświetlamy przycisk "Close" wewnątrz formularza (lub user może zamknąć 'X')
      actions={
        !success && (
          <>
            <SecondButton onClick={handleClose} disabled={loading}>
              Cancel
            </SecondButton>
            <MainButton onClick={handleSubmit} disabled={loading}>
              {loading ? "Sending..." : "Submit Request"}
            </MainButton>
          </>
        )
      }
    >
      <div className="profile-modal-form">
        <p className="refund-desc" style={{ marginBottom: "0.3rem" }}>
          Please describe the issue with your eSIM. Our team will review your request and contact you shortly.
        </p>

        <label>
          Reason for Refund
          <textarea
            className="main-input"
            rows={5}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Describe why you need a refund..."
            style={{ resize: "vertical", padding: "0.8rem", fontFamily: "inherit" }}
            // Blokujemy edycję podczas ładowania LUB gdy wysłano pomyślnie
            disabled={loading || success}
          />
        </label>

        {/* Miejsce na błąd */}
        {error && (
          <div className="profile-modal-error-wrapper">
            <ErrorMessage message={error} onClose={() => setError("")} />
          </div>
        )}

        {/* Miejsce na sukces - teraz pojawia się pod formularzem zamiast go zastępować */}
        {success && (
          <div className="profile-modal-success-wrapper">
            <SuccessMessage
              message="Your refund request has been received. We will review it and get back to you soon."
              onClose={() => {}}
            />
            {/* Opcjonalnie: Przycisk zamknięcia pod wiadomością sukcesu */}
            <div style={{ marginTop: "1rem", display: "flex", justifyContent: "flex-end" }}>
              <MainButton onClick={handleClose}>Close</MainButton>
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default RefundModal;
